import React from 'react';
import SMFormFieldBaseView from 'components/dashboard/form/SMFormFieldBaseView';

class SMFormRadio extends SMFormFieldBaseView {
  
  shouldComponentUpdate(nextProps, nextState) {
    return true;
  }
  
  onFocus(e) {
    
  }
  
  onBlur(e) {
    
  }
  
  didChangeValue(e) {
    if(this.props.delegate && typeof this.props.delegate.radioButtonDidChangeValue === 'function'){
      this.props.delegate.radioButtonDidChangeValue(e);
    }
  }

  render() {
    
    let items = [];
    for (let i = 0; i < this.props.items.length; i++) {
      let id = this.props.name + "[" + i + "]",
          checked = (this.props.selectedValue == this.props.items[i].value),
          disabled = (this.props.items[i].disabled === true);
      items.push(
        <input type="radio" value={this.props.items[i].value} key={id} id={id} name={this.props.name} disabled={disabled} defaultChecked={checked} onChange={this.didChangeValue.bind(this)} />
      );
      items.push(
        <label htmlFor={id} key={id+"-label"} className={"form-radio " + this.props.options.className}>{this.props.items[i].label}</label>
      );
    }
    
    return (
      <div>
        {items}
      </div>
    );
  }
}

SMFormRadio.defaultProps = {
  items: [],
  options: {
    className: "w72",
  },
};

export default SMFormRadio;


// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/form/SMFormRadio.jsx